import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

const awardsBlock = {
  title: 'Awards & Honors',
  items: [
    {
      year: '2026',
      text: 'Link Foundation Modeling, Simulation & Training Fellowship',
    },
    {
      year: '2023',
      text: 'Best Paper Award, ACM ISS',
    },
    {
      year: '2021',
      text: 'Best Paper Award & Methods Recognition, ACM CSCW',
    },
    {
      year: '2023',
      text: '10th Heidelberg Laureate Forum Young Researcher',
    },
    {
      year: '2020',
      text: 'NAVER Ph.D. Fellowship',
    },
    {
      year: '2026',
      text: 'XRTC Creative Research Grant',
    },
    {
      year: '2023–24',
      text: 'Sponsored Research by Meta Reality Labs',
    },
    {
      year: '2021',
      text: 'Bell Labs Summer Intern Award for Outstanding Innovation',
    },
    {
      year: '2019',
      text: 'Best Video Award, ACM MobiSys',
    },
    {
      year: '2019',
      text: 'Google Women Techmakers Scholar',
    },
    {
      year: '2020–26',
      text:
        '22× Special Recognitions for Outstanding Reviews (CHI, UIST, IMWUT, CSCW, NordiCHI)',
    },
  ],
};

const serviceBlocks = [
  {
    title: 'Academic Service',
    items: [
      {
        year: '2026–27',
        text: 'Posters Co-Chair, ACM UIST 2026 & 2027',
      },
      {
        year: '2025',
        text: 'Registration Co-Chair & Session Chair, ACM UIST 2025',
      },
      {
        year: '2024–27',
        text:
          'Program Committee, ACM CHI 2027, SIGGRAPH Asia 2026 Technical Communications & Posters, CHI Late-Breaking Work 2024–25',
      },
      {
        year: '2024',
        text: 'Subcommittee Chair Assistant, ACM CHI 2024 (Interacting with Devices)',
      },
      {
        year: '2020–',
        text:
          'Reviewer for CHI, UIST, ISMAR, IEEE VR, DIS, VRST, NordiCHI, MobileHCI, SUI, SIGGRAPH Posters, TOCHI, TVCG, IMWUT, CSCW, TAP, and more',
      },
      {
        year: '2022–25',
        text:
          'CMU SCS Graduate Application Support Program (GASP); Women/Non-binary Lunch Organizer',
      },
    ],
  },
  {
    title: 'Teaching & Mentoring',
    items: [
      {
        year: '2019–',
        text:
          'Guest lecturer on XR, computational interaction, and human-AI interaction at CMU, University of Rochester, University of Michigan, and KAIST',
      },
      {
        year: '2016–',
        text:
          'Teaching assistant for HCI and computing courses at CMU and KAIST, including Best TA Award (KAIST, 2019)',
      },
      {
        year: '2018–',
        text:
          'Mentored 16 undergraduate and graduate researchers, many continuing to Ph.D. programs and industry research',
      },
    ],
  },
];

const ServiceSection = ({ size }) => {
  const theme = useTheme();
  const isSmall = size === 'small' || size === 'medium';

  const renderBlock = (block) => (
    <Box key={block.title} mb={isSmall ? 3 : 4}>
      <Typography
        variant="h6"
        style={{ fontWeight: 700, marginBottom: 8 }}
      >
        {block.title}
      </Typography>
      {block.items.map((item) => (
        <Box
          key={`${item.year}-${item.text}`}
          display="flex"
          flexDirection="row"
          mb={1}
        >
          <Typography
            variant="body2"
            style={{
              color: theme.customColors.bullet,
              marginRight: 10,
              flexShrink: 0,
            }}
          >
            •
          </Typography>
          <Typography variant="body2">{item.text}</Typography>
        </Box>
      ))}
    </Box>
  );

  return (
    <Box
      display="grid"
      style={{
        gridTemplateColumns: isSmall ? '1fr' : '1fr 1fr',
        columnGap: 32,
      }}
    >
      <Box>{serviceBlocks.map(renderBlock)}</Box>
      <Box>{renderBlock(awardsBlock)}</Box>
    </Box>
  );
};

export { ServiceSection };
